<template>
  <div id="jumbotron">
    <div class="container">
      <h1 v-html="$t('englishClassPage.title')"></h1>
    </div>
  </div>

  <div class="container pt-5 mt-5">
    <div class="row m-0">
      <div class="col-12 col-md-7">
        <h2 class="text-primary mb-4">
          {{ $t('englishClassPage.subTitle') }}
        </h2>

        <div v-html="$t('englishClassPage.description')"></div>
    
        <ul class="pb-4" v-html="$t('englishClassPage.points')"></ul>

        <div class="pb-5">
          <a href="https://english-matters.s3.ap-southeast-1.amazonaws.com/files/English+Matters+2025+Term+Dates.pdf" target="_blank" class="btn btn-secondary px-4 py-2 fw-bold me-5">
            {{ $t('englishClassPage.termDates') }}
          </a>
          <a href="https://english-matters.s3.ap-southeast-1.amazonaws.com/files/2025+Fee+Structure+%26+Timetable.pdf" target="_blank" class="btn btn-secondary px-4 py-2 fw-bold">
            {{ $t('englishClassPage.feeStructure') }}
          </a>
        </div>
      </div>
    </div>

    <div class="row m-0">
      <div class="col-12 col-md-6">
        <div class="section-container p-5">
          <h2 class="section-title text-secondary">5-11</h2>
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/classes+5+to+11.webp" 
                alt="Classes for 5 to 11 years old" class="w-100 shadow">
        </div>
      </div>
      <div class="col-12 col-md-6 bg-color p-5">
        <h3 class="text-primary">
          {{ $t('englishClassPage.primary.title') }}
        </h3>
        <p class="fw-bold">
          {{ $t('englishClassPage.primary.description') }}
        </p>

        <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-5-11-years-old-kids/">
          {{ $t('englishClassPage.learnMore') }}
        </router-link>
      </div>
    </div>

    <div class="row flex-row-reverse m-0">
      <div class="col-12 col-md-6">
        <div class="section-container p-5">
          <h2 class="section-title text-secondary">12-19</h2>
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/classes+12+to+19.webp" 
                alt="Classes for 12 to 19 years old" class="w-100 shadow">
        </div>
      </div>
      <div class="col-12 col-md-6 bg-color p-5">
        <h3 class="text-primary">
          {{ $t('englishClassPage.secondary.title') }}
        </h3>

        <div v-html="$t('englishClassPage.secondary.description')"></div>
        
        <p>
          {{ $t('englishClassPage.secondary.cta') }}
          <router-link to="/english-classes/cambridge-english-exams-in-petaling-jaya/">
            {{ $t('englishClassPage.secondary.ctaText') }}
          </router-link>.
        </p>

        <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-12-19-years-old-kids/">
          {{ $t('englishClassPage.learnMore') }}
        </router-link>
      </div>
    </div>
    
    <div class="row m-0">
      <div class="col-12 col-md-6">
        <div class="section-container p-5">
          <h2 class="section-title text-secondary">
            {{ $t('englishClassPage.adult.adults') }}
          </h2>
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/classes+adult.webp" 
                alt="Classes for Adults" class="w-100 shadow">
        </div>
      </div>
      <div class="col-12 col-md-6 bg-color p-5">
        <h3 class="text-primary">
          {{ $t('englishClassPage.adult.title') }}
        </h3>

        <div v-html="$t('englishClassPage.adult.description')"></div>
        
        <ul v-html="$t('englishClassPage.adult.points')">
        </ul>

        <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-adults/">
          {{ $t('englishClassPage.learnMore') }}
        </router-link>
      </div>
    </div>
  </div>

  <div id="creativeClass" class="bg-color py-5 mt-5">
    <div class="container">
      <h3 class="text-center text-secondary">
        {{ $t('englishClassPage.creativeWriting.title') }}
      </h3>
      <div class="row m-0">
        <div class="col-12 col-md-6 px-5">
          <div v-html="$t('englishClassPage.creativeWriting.description')"></div>

          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/school-holidays-english-class/">
            {{ $t('englishClassPage.learnMore') }}
          </router-link>
        </div>
        <div class="col-12 col-md-6">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/classes+creative+writing.webp" 
                alt="Classes for Creative Writing" class="w-100 shadow">
        </div>
      </div>
    </div>
  </div>

  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 1.8em; }
h3 { font-size: 1.5em; }

.section-container {
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/chat-bubble-4.png");
  background-position: left 0 top 100px;
  background-repeat: no-repeat;
  text-align: center;
  margin-bottom: 3em;
}
.section-title {
  font-size: 7em;
  text-align: left;
  padding-left: 0.2em;
}
.section-container img {
  max-width: 375px;
  height: auto;
  margin: auto;
}
.bg-color {
  background-color: #F4F3F9;
}

#creativeClass h3 {
  font-size: 7em;
}

#creativeClass img {
  max-width: 450px;
  margin: auto;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>